(function () {
  var states = [];

  function applyGating(state, variantId) {
    var isGated = state.variantMap[String(variantId)] === true;
    var showLogin = isGated && !state.customerLoggedIn;
    if (showLogin) {
      state.loginBtn.removeAttribute('hidden');
      state.formWrapper.setAttribute('hidden', '');
    } else {
      state.loginBtn.setAttribute('hidden', '');
      state.formWrapper.removeAttribute('hidden');
    }
  }

  function registerScript(mapScript) {
    if (mapScript.__variantLoginRegistered) return;
    mapScript.__variantLoginRegistered = true;

    var data;
    try { data = JSON.parse(mapScript.textContent); } catch (e) { return; }

    var scope = mapScript.parentElement;
    if (!scope) return;

    var loginBtn = scope.querySelector('[data-login-to-purchase="' + data.productId + '"]');
    var formWrapper = scope.querySelector('[data-atc-form-wrapper="' + data.productId + '"]');
    if (!loginBtn || !formWrapper) return;

    var state = {
      productId: String(data.productId),
      customerLoggedIn: data.customerLoggedIn,
      variantMap: data.variants || {},
      loginBtn: loginBtn,
      formWrapper: formWrapper,
      scope: scope,
      lastVariantId: null
    };

    states.push(state);

    // Apply gating immediately for the currently selected variant in this scope.
    var container = mapScript.closest('[data-is-quick-view]')
      || mapScript.closest('form[data-product-form]')
      || document;
    var initialForm = container.querySelector
      ? container.querySelector('[data-product-form]')
      : null;
    if (initialForm) {
      var sel = initialForm.querySelector('[data-variant-select]');
      if (sel && sel.value && state.variantMap.hasOwnProperty(String(sel.value))) {
        state.lastVariantId = String(sel.value);
        applyGating(state, sel.value);
      }
    }
  }

  function handleChange(e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-product-form')) return;

    var sel = form.querySelector('[data-variant-select]');
    if (!sel) return;
    var variantId = String(sel.value);

    states.forEach(function (state) {
      if (!state.variantMap.hasOwnProperty(variantId)) return;
      // Skip states whose buttons are no longer in the document (e.g., closed modal).
      if (!document.contains(state.loginBtn)) return;
      if (variantId === state.lastVariantId) return;
      state.lastVariantId = variantId;
      applyGating(state, variantId);
    });
  }

  function scanAll(root) {
    var scope = root || document;
    var maps = scope.querySelectorAll('script[data-variant-login-map]');
    maps.forEach(registerScript);
  }

  function init() {
    scanAll();
    document.addEventListener('change', handleChange, true);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('script[data-variant-login-map]')) {
            registerScript(node);
          }
          if (node.querySelectorAll) {
            scanAll(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
